import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=e6012184&scoped=true&"
import script from "./InventoryDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetail.vue?vue&type=style&index=0&id=e6012184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6012184",
  null
  
)

export default component.exports